import { Header } from "antd/es/layout/layout";
import { useLocation } from "react-router-dom";
import Navigator from "../Navigator";


const AppHeader = () => {
  const location = useLocation();
  const { pathname } = location;

  let path = pathname?.split("/")?.slice(0, 2).join("/");

  const excludedPaths = [
    "/sign-in",
    "/sign-up",
    "/forgot-password",
    "/reset-password",
    "/onboarding",
    "/initial-loading",
  ];

  const shouldRenderHeader = !excludedPaths.includes(path);

  if (!shouldRenderHeader) {
    return null;
  }

  return (
    <Header style={{ padding: 0 }}>
      <Navigator/>
    </Header>
  );
};

export default AppHeader;
